export function isNativeApp() {
  return !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
}

export function getPlatform() {
  if (!isNativeApp()) return 'web';
  const p = window.Capacitor.getPlatform && window.Capacitor.getPlatform();
  return p || 'web';
}
